/**
 * Ad Configuration
 *
 * To enable ads and content gating:
 * 1. Set ENABLED: true
 * 2. Choose your PROVIDER ('adsense', 'propeller', etc.)
 * 3. Past daily challenges will require ads to unlock
 *
 * To disable ads (free access):
 * 1. Set ENABLED: false
 * 2. All past daily challenges become free
 */
export const ADS_CONFIG = {
  // Master switch - set to true to enable ad gating, false for free access
  ENABLED: false,

  // Ad provider settings (for when ads are enabled)
  PROVIDER: "mock", // 'mock' | 'adsense' | 'propeller' | 'media-net'

  // Ad timing
  DURATION_SECONDS: 5,

  // What gets gated when ads are enabled
  GATE_PAST_DAILIES: true,
  GATE_REGULAR_GAMES: false, // Future: gate regular games too
} as const;

// Helper functions
export const areAdsEnabled = () => ADS_CONFIG.ENABLED;
export const shouldGatePastDailies = () =>
  ADS_CONFIG.ENABLED && ADS_CONFIG.GATE_PAST_DAILIES;
export const shouldGateRegularGames = () =>
  ADS_CONFIG.ENABLED && ADS_CONFIG.GATE_REGULAR_GAMES;
